// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryGridStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Category Grid Store
 */
!(function() {
  var extendObservable = require('mobx').extendObservable;
  var observe = require('mobx').observe;
  var advancedSettingsDataFetcher = require('fetchers/Izenda.AdvancedSettingDataFetcher');
  var CategoryMetadata = require('logic/models/Izenda.CategoryMetadata');
  var commonMessages = require('share/messages/Izenda.CommonMessages');
  var uiState = require('logic/Izenda.UiState');
  var localizer = require('share/localization/Izenda.Localizer');

  const {isEmpty, some, map, isObject, findIndex, remove, invoke} = require('lodash/fp');

  /**
   * contructor
   */
  function CategoryGridStore(tenantId) {
    this.tenantId = tenantId || '';
    this.lastAddCategory = null;

    extendObservable(this, {
      categoryMetadatas: [],

      alertMessage: commonMessages.EMPTY_MESSAGE,
      hasChange: function() {
        return some(['isDirty', true], this.categoryMetadatas);
      }
    });
  }

  /**
   * get init store when component mount
   */
  (CategoryGridStore.prototype.init = function() {
    this.observeTenantId();
    uiState.setCheckDirtyFunction(
      function() {
        return this.hasChange;
      }.bind(this)
    );

    return this.getInitial();
  }),
    /**
     * unlick between uiState on store
     * @return {[type]} [description]
     */
    (CategoryGridStore.prototype.destroy = function() {
      this.disposeCategoryGrid();
      uiState.resetCheckDirtyFunction();
    });
  /**
   * observe tenantID on setting level
   */
  CategoryGridStore.prototype.observeTenantId = function() {
    this.disposeCategoryGrid = observe(
      uiState,
      'tenantId',
      function() {
        this.getInitial(uiState.getTenantId());
      }.bind(this)
    );
  };

  CategoryGridStore.prototype.getInitial = function() {
    this.alertMessage = commonMessages.EMPTY_MESSAGE;
    return this.getCategories(uiState.getTenantId());
  };

  /**
   * get category from db
   */
  CategoryGridStore.prototype.getCategories = function(tenantId) {
    tenantId = tenantId || this.tenantId;
    var handleAfterGetCategories = function(result) {
      result = result || {};
      this.categoryMetadatas = result.map(function(item) {
        var categoryMetadata = new CategoryMetadata(item);
        return categoryMetadata;
      });
      return null;
    }.bind(this);

    this.categoryMetadatas = [];
    this.lastAddCategory = null;

    return advancedSettingsDataFetcher.getAllCategories(tenantId).then(handleAfterGetCategories.bind(this));
  };

  /**
   * save all category to DB
   */
  CategoryGridStore.prototype.saveCategories = function() {
    function showErrorMessages(result) {
      var message = localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED');
      if (!result.success) {
        var messageData = result.messages[0];
        if (isObject(messageData)) {
          message = messageData.messages;
        } else {
          message = messageData;
        }
      }

      this.alertMessage = {
        type: result.success ? 'success' : 'error',
        message: message
      };
      result.success && this.getCategories(uiState.getTenantId());

      return result;
    }

    var request = map(invoke('prepareRequestJSON'), this.categoryMetadatas);
    return advancedSettingsDataFetcher.saveCategories(request).then(showErrorMessages.bind(this));
  };

  /**
   * add category item
   */
  CategoryGridStore.prototype.addCategory = function(value, label) {
    var item = {
      name: label,
      id: value,
      isNew: true
    };

    var categoryMetadata = new CategoryMetadata(item);
    if (findIndex(this.categoryMetadatas, categoryMetadata) < 0) {
      this.categoryMetadatas.push(categoryMetadata);
    }
  };

  /**
   * add empty category
   */
  CategoryGridStore.prototype.addEmptyCategory = function() {
    var categoryMetadata = new CategoryMetadata();
    categoryMetadata.markDirty();
    this.categoryMetadatas.unshift(categoryMetadata);
    this.lastAddCategory = categoryMetadata;
  };

  /**
   * delete category from DB
   */
  CategoryGridStore.prototype.delCategory = function(item) {
    if (!isEmpty(item.id)) {
      var handleAfterDeleteCategory = function(result) {
        if (result.success) {
          this.categoryMetadatas = remove(
            {
              key: item.key
            },
            this.categoryMetadatas
          );
        } else {
          this.getCategories(null);
        }
        return result;
      }.bind(this);

      return advancedSettingsDataFetcher.deleteCategory(item.id).then(handleAfterDeleteCategory);
    } else {
      this.categoryMetadatas = remove(
        {
          key: item.key
        },
        this.categoryMetadatas
      );
    }
    return null;
  };

  /**
   * new name value for category
   */
  CategoryGridStore.prototype.updateCategoryName = function(item, value) {
    item.name = value;
    item.markDirty();
  };

  module.exports = CategoryGridStore;
})();



// WEBPACK FOOTER //
// ./ui/logic/Izenda.CategoryGridStore.js